import CryptoJS  from 'crypto-js';
// function to encrypt data
export function encrypt(data) {
    var key = CryptoJS.enc.Utf8.parse('%KCSWATCH%^$$%@J');
    var iv = CryptoJS.enc.Utf8.parse('^$%#^%LEVVITC375');
    var encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
    });
    return encrypted.toString();
}
// function to decrypt data
export function decrypt(data) {
    var key = CryptoJS.enc.Utf8.parse('%KCSWATCH%^$$%@J');
    var iv = CryptoJS.enc.Utf8.parse('^$%#^%LEVVITC375');
    var decrypted = CryptoJS.AES.decrypt(data, key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
}